var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.i18nt('designer.setting.minValue')}},[_c('el-input-number',{staticClass:"hide-spin-button",staticStyle:{"width":"100%"},model:{value:(_vm.minValue),callback:function ($$v) {_vm.minValue=$$v},expression:"minValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }